import React from 'react';
import {
  FDDisplayText, FDHeadlineText,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';


export const Title = (props) => {
  const isMobile = useMobileLayout();

  const color = 'textSecondary';

  if (isMobile) {
    return <FDHeadlineText color={color} {...props} size={'lg'} />;
  }
  return (
    <FDDisplayText {...props} color={color} align={'center'} />
  );
};
